// extracted by mini-css-extract-plugin
export var downArrow = "_9l-0";
export var label = "_9l-1";
export var treatmentCard = "_9l-3";
export var upArrow = "_9l-2";